<div class="canvas-wrapper">
  <canvas #builderCanvas width="300" height="300" class="canvas-reg">
  </canvas>        
</div>